import { LoggerModule } from 'ngx-logger';
import { provideRouter } from '@angular/router';
import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';

import { routes } from './app-routing';
import { environment } from '../environments/environment';
import { UIErrorHandler } from './error-handler';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { LoggingInterceptor } from './interceptors/logging.interceptor';
import { AuthService } from './services/auth.service';
import { BreadcrumbService } from './services/breadcrumb.service';
import { ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HospitalChangeService } from './services/hospital-change.service';
import { IndicatorResolverService } from './services/indicator-resolver.service';
import { IframeService } from './services/iframe.service';
import { PendoService } from './services/pendo.service';
import { SubscriptionChangeService } from './services/subscription-change.service';
import { TimeoutService } from './services/timeout-service.service';
import { UserNavigationService } from './services/user-navigation.service';
import { UserNavigationMappingService } from './services/user-navigation-mapping.service';
import { WindowEventsService } from './services/window-events.service';

export const appConfig = {
  providers: [
    ConfirmationService,
    CookieService,
    DeviceDetectorService,
    provideAnimationsAsync(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi()
    ),
    importProvidersFrom(
      AuthService,
      BreadcrumbService,
      HospitalChangeService,
      IframeService,
      IndicatorResolverService,
      PendoService,
      SubscriptionChangeService,
      TimeoutService,
      UserNavigationService,
      UserNavigationMappingService,
      WindowEventsService,
      LoggerModule.forRoot({
        serverLoggingUrl: environment.LogService,
        level: environment.LogLevel,
        serverLogLevel: environment.ServerLogLevel,
        disableConsoleLogging: environment.DisableConsoleLogging
      }),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    { provide: ErrorHandler, useClass: UIErrorHandler },
  ]
};
